import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HistoryRequestsState } from './history-requests.state';

// selectors
export const selectHistoryRequestsModule = createFeatureSelector<HistoryRequestsState>('historyRequests');
export const selectHistoryRequestsList = createSelector(selectHistoryRequestsModule,
    (state: HistoryRequestsState) => state.historyRequestList);

export const selectHistoryRequestsParams = createSelector(selectHistoryRequestsModule,
    (state: HistoryRequestsState) => state.historyRequestParams);

export const selectServiceProvider = createSelector(selectHistoryRequestsModule,
    (state: HistoryRequestsState) => state.historyRequestParams ? state.historyRequestParams.serviceProvider : null);

export const selectHistoryRequestsParamsAccount = createSelector(selectHistoryRequestsModule,
    (state: HistoryRequestsState) => state.historyRequestParams ? state.historyRequestParams.userAccount : null);

export const selectHistoryRequestsParamsRequestType = createSelector(selectHistoryRequestsModule,
    (state: HistoryRequestsState) => state.historyRequestParams ? state.historyRequestParams.requestType : null);

// ---------------------------------------------------------------------------------------------------------------------

export const selectUserAccounts = createSelector(selectHistoryRequestsModule,
    (state: HistoryRequestsState) => state.userAccounts);

// ---------------------------------------------------------------------------------------------------------------------

export const selectServiceUnavailable = createSelector(selectHistoryRequestsModule,
    (state: HistoryRequestsState) => state.serviceUnavailable);

// ---------------------------------------------------------------------------------------------------------------------

export const selectLoadingStatus = createSelector(selectHistoryRequestsModule,
    (state: HistoryRequestsState) => state ? state.loadingStatus : null);

export const selectLoadingError = createSelector(selectHistoryRequestsModule,
    (state: HistoryRequestsState) => state ? state.loadingError : null);

// ---------------------------------------------------------------------------------------------------------------------

export const selectServiceProvidersSearchText = createSelector(selectHistoryRequestsModule,
    (state: HistoryRequestsState) => state.serviceProvidersSearchText);

export const selectServiceProviders = createSelector(selectHistoryRequestsModule,
    (state: HistoryRequestsState) => state.serviceProviders);




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/history-requests/history-requests.selector.ts